/**
 * The invoices that count against `invoicesPerMonth`: rows created since the
 * 1st of the current UTC month, imported invoices excluded — taking over an
 * old invoice is not issuing a new one. Pure, so the dashboard gauge counts
 * exactly what the create guard counts.
 */
export function countQuotaInvoices(
  bills: ReadonlyArray<{ createdAt: number; importedFrom?: unknown }>,
  now: number,
): number {
  const today = new Date(now);
  const monthStart = Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 1);
  return bills.filter(
    (bill) => bill.createdAt >= monthStart && bill.importedFrom === undefined,
  ).length;
}
